module.exports = __webpack_public_path__ + "static/img/project.f21a3f1e.svg";